import React from 'react';

import { generateTrackingAttributes } from '../../../utils/tracking';
import GdprOptIn from './GdprOptIn';

export default function LockedLeadCaptureForm({
  buttonText,
  emailPlaceholderText = 'Enter your email',
  endpointUri,
  forceEmailAuth = false,
  isGdprLead = false,
  leadType,
  redirectUri,
  trackingProps = {},
}: {
  buttonText: string;
  emailPlaceholderText?: string;
  endpointUri: string;
  forceEmailAuth?: boolean;
  isGdprLead?: boolean;
  leadType: string;
  redirectUri: string;
  trackingProps?: { [key: string]: string };
}) {
  const trackClick = Object.keys(trackingProps).length > 0;

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    /* eslint-disable no-undef */
    // TODO: remove sprockets and import explictly with webpack
    // @ts-expect-error coming from sprockets
    createLeadLockedHomepage(e);
    /* eslint-enable no-undef */
  };

  return (
    <div className="get-started-form-group">
      <div className="get-started-action-group">
        <input type="text" className="get-started-input" placeholder={emailPlaceholderText} />
        <span className="get-started-btn-container">
          {isGdprLead && <GdprOptIn />}
          <a
            type="submit"
            className={`get-started-button ${trackClick ? 'track-click' : ''}`}
            data-submit-uri={endpointUri}
            data-redirect-uri={redirectUri}
            data-lead-type={leadType}
            data-force-email-auth={forceEmailAuth}
            onClick={handleSubmit}
            {...generateTrackingAttributes(trackingProps)}
          >
            {buttonText}
          </a>
        </span>
      </div>
      <div className="get-started-error"></div>
    </div>
  );
}
